import { FC } from "react";
import {
    Box,
    Flex,
    Grid,
    GridItem,
    Heading,
    Text,
    useBreakpointValue,
} from "@smile2impress/components/relaunch";

import { CtaButton } from "components/CtaButton";

import { VerticalAdvantagesProps } from "./VerticalListSection.types";
import { ListItem } from "./components/ListItem";

export const VerticalListSection: FC<VerticalAdvantagesProps> = ({
    content,
    headingAs,
}) => {
    const { title, subtitle, cta, items } = content;

    const isMobile = useBreakpointValue({
        base: true,
        tablet: true,
        desktop: false,
    });

    return (
        <>
            <Grid
                gridTemplateColumns={["1fr", "1fr", "repeat(24, 1fr)"]}
                gridColumnGap={["initial", "initial", 2]}
            >
                <GridItem
                    colStart={["auto", "auto", 2]}
                    colSpan={["auto", "auto", 10]}
                >
                    <Box px={[2, 2, 0]} pb={[3, 3, 0]} h="100%">
                        {title && (
                            <Heading
                                as={headingAs}
                                textStyle="title1"
                                color="text.base"
                            >
                                {title}
                            </Heading>
                        )}

                        {subtitle && (
                            <Text
                                textStyle="body"
                                color="text.base"
                                mt={[1, 1, 1]}
                            >
                                {subtitle}
                            </Text>
                        )}

                        {!isMobile && cta && (
                            <Box mt={2}>
                                <CtaButton {...cta} />
                            </Box>
                        )}
                    </Box>
                </GridItem>

                <GridItem
                    colStart={["auto", "auto", 13]}
                    colSpan={["auto", "auto", 11]}
                >
                    <Flex direction="column" gap={[3, 3, 4]} px={[2, 2, 0]}>
                        {items.map((item, index) => (
                            <ListItem key={index} {...item} />
                        ))}
                    </Flex>
                </GridItem>
            </Grid>

            {isMobile && cta && (
                <Box mt={3} px={2}>
                    <CtaButton {...cta} />
                </Box>
            )}
        </>
    );
};
